import { PropsWithChildren, ReactElement, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useGlobalStore } from "../../../../store";
import { QueryClientProvider } from "@tanstack/react-query";
import { sharedQueryClient } from "@/query-client";

interface Props {
  children: ReactElement;
  to?: string;
}

const WrapperProvider = ({ children }: PropsWithChildren<any>) => {
  return (
    <QueryClientProvider client={sharedQueryClient}>
      {children}
    </QueryClientProvider>
  );
};
export default function RedirectIfAuthenticated(props: Props) {
  const { state } = useGlobalStore();
  const navigate = useNavigate();
  const redirectTo = props.to ? props.to : "/home";

  useEffect(() => {
    if (state.isUserLoggedIn) {
      navigate(redirectTo, { replace: true, state: { isRedirected: true } });
    }
  }, [state.isUserLoggedIn, redirectTo, navigate]);

  if (state.isUserLoggedIn) {
    return null;
  }

  return <WrapperProvider>{props.children}</WrapperProvider>;
}
